import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useBreadcrumbStore } from '@/store/breadcrumbs';

export function BreadcrumbLocationSync() {
    const location = useLocation();
    const items = useBreadcrumbStore((state) => state.items);
    const activeUrl = useBreadcrumbStore((state) => state.activeUrl);
    const pendingNavigationUrl = useBreadcrumbStore((state) => state.pendingNavigationUrl);
    const setInitialTrail = useBreadcrumbStore((state) => state.setInitialTrail);
    const applyNavigation = useBreadcrumbStore((state) => state.applyNavigation);
    const consumePendingNavigation = useBreadcrumbStore((state) => state.consumePendingNavigation);

    useEffect(() => {
        const currentUrl: string = `${location.pathname}${location.search}${location.hash}`;

        if (pendingNavigationUrl !== null) {
            if (consumePendingNavigation(currentUrl)) {
                return;
            }

            return;
        }

        if (currentUrl === activeUrl) {
            return;
        }

        const hasCurrentUrl: boolean = items.some((item) => item.url === currentUrl);
        if (hasCurrentUrl) {
            applyNavigation('browser_history', { url: currentUrl });
            return;
        }

        const hasOnlyDashboardRoot: boolean = items.length === 1 && items[0]?.url === '/dashboard';

        if (hasOnlyDashboardRoot || items.length === 0) {
            setInitialTrail({ url: currentUrl });
            return;
        }

        applyNavigation('browser_history', { url: currentUrl });
    }, [
        activeUrl,
        applyNavigation,
        consumePendingNavigation,
        items,
        location.hash,
        location.pathname,
        location.search,
        pendingNavigationUrl,
        setInitialTrail,
    ]);

    return null;
}
